import React, { useEffect, useState } from "react";
import { Input } from "antd";
import SC from "./style";
import { regexPattern } from "utils/config";

const { TextArea } = Input;

const TextInput = (props) => {
  const {
    defaultValue = "",
    name,
    onChange = () => {},
    variant = "outlined",
    disabled = false,
    suffix,
    style,
    size = "small",
    type,
    min,
    max,
    placeholder,
    addonbefore,
    addonafter,
    prefix,
    isError = false,
    isTextArea = false,
    required = false,
    focus = false,
    autoFocus = false,
    regexType,
    maxLength = 100,
    allowClear = false,
  } = props;

  const [focused, setFocused] = useState(focus);
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleKeyPress = (e) => {
    if (defaultValue !== value) {
      onChange(value, name);
    }
    setFocused(false);
  };

  const handleFocus = () => {
    setFocused(true);
    setError(false); // Reset error on focus
  };

  const validateValue = (val) => {
    if (regexType) {
      const regex = new RegExp(regexPattern[regexType]);
      if (!regex.test(val)) {
        setError(true);
        return value; // Keep the previous valid value
      }
    }
    setError(false);
    return val;
  };

  const handleChange = (e) => {
    let { value } = e.target;

    if (type === "number") {
      value = Math.max(parseInt(value, 10) || 0, min || 0);
    }

    value = validateValue(value.trimStart());
    setValue(value);
  };

  return (
    <>
      {SC.GlobalStyles}
      {isTextArea ? (
        <TextArea
          value={value}
          min={min}
          max={max}
          placeholder={placeholder}
          size={size}
          name={name}
          variant={focused || error || isError ? "outlined" : variant}
          onPressEnter={handleKeyPress}
          onBlur={(e) => handleKeyPress(e)}
          onFocus={handleFocus}
          onChange={handleChange}
          maxLength={maxLength}
          style={style}
          disabled={disabled}
          suffix={suffix}
          addonbefore={addonbefore}
          addonafter={addonafter}
          status={error || isError ? "error" : undefined}
          prefix={prefix}
          required={required}
          autoFocus={autoFocus}
          allowClear={allowClear}
        />
      ) : (
        <Input
          value={value}
          type={type}
          variant={focused || error || isError ? "outlined" : variant}
          min={min}
          max={max}
          placeholder={placeholder}
          size={size}
          name={name}
          onPressEnter={handleKeyPress}
          onBlur={(e) => handleKeyPress(e)}
          onFocus={handleFocus}
          onChange={handleChange}
          style={style}
          disabled={disabled}
          suffix={suffix}
          addonbefore={addonbefore}
          addonafter={addonafter}
          status={error || isError ? "error" : undefined}
          prefix={prefix}
          required={required}
          autoFocus={autoFocus}
        />
      )}
    </>
  );
};

export default TextInput;
